// 陕西中犇物资有限公司
const zblb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zblb1.png";
const zblb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zblb2.JPG";
const zblb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zblb2.JPG";
const zblb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zblb2.JPG";
const zblb5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zblb2.JPG";
const zbvideoUrl = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbsp.mp4";
const zbvideoLogo = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbfm.jpg";
const zbcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp1.png";
const zbcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp2.png";
const zbcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp3.png";
const zbcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp4.png";
const zbcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp5.png";
const zbcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp6.png";
const zbcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp7.png";
const zbcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp8.png";
const zbcp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp9.png";
const zbcp10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp10.png";
const zbcp11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp11.png";
const zbcp12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp12.png";
const zbcp13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp13.png";
const zbcp14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp14.png";
const zbcp15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp15.png";
const zbcp16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp16.png";
const zbcp17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp17.png";
const zbcp18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp18.png";
const zbcp19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp19.png";
const zbcp20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp20.png";
const zbcp21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp21.png";
const zbcp22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp22.png";
const zbcp23 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp23.png";
const zbcp24 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp24.png";
const zbcp25 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbcp25.png";

const zbbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg1.png";
const zbbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg2.png";
const zbbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg3.png";
const zbbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg4.png";
const zbbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg5.png";
const zbbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg6.png";
const zbbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg7.png";
const zbbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg8.png";
const zbbg9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg9.png";
const zbbg10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg10.png";
const zbbg11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg11.png";
const zbbg12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbbg12.png";

const zbgc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc1.png";
const zbgc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc2.png";
const zbgc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc3.png";
const zbgc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc4.png";
const zbgc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc5.png";
const zbgc6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc6.png";
const zbgc7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc7.png";
const zbgc8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc8.png";
const zbgc9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc9.png";
const zbgc10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbgc10.png";

const zbht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht1.png";
const zbht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht2.png";
const zbht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht3.png";
const zbht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht4.png";
const zbht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht5.png";
const zbht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht6.png";
const zbht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht7.png";
const zbht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht8.png";
const zbht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht9.png";
const zbht10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht10.png";
const zbht11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht11.png";
const zbht12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbht12.png";

const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
	homeData: {
		herderBanner: [zblb1, zblb2, zblb3, zblb4, zblb5],
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/logo.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbfm.jpg",
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: true,
		videoLogo: zbvideoLogo,
		videoUrl: zbvideoUrl,
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `陕西中犇物资有限公司成立于2019年12月19日，注册资金：2000万元，公司位于陕西省西安市雁塔区太白南路71号悦熙广场，是一家专业化生产建筑用灰、工业用灰以及大综建筑地材生产与建筑材料批发的民营企业。公司生产技术人员15名，销售团队20名及相关人员共56名，专业运输团队50余辆，具有雄厚的经济实力和商业信誉，自成立以来公司一直本着“诚信、务实”的承诺，“快速、高效”的服务原则，“勤勉中犇、飞腾建设”的经营理念，“奋进发展、质量生存”的质量要求，“不屈不挠、勇于创新”的团队风采，“勤奋、敬业、团结、合作”的企业精神，不停脚步，继续向前，为未来而来。`,
		//公司官网
		website: "",
		operatingStatus: "正常在业",
		//经营品类
		categories: `建筑材料销售，办公用品销售，日用杂品销售，五金产品销售等`,
		//公司地址
		companyAddress: "陕西省西安市雁塔区太白南路71号3号楼1127室",
		site: "陕西省西安市雁塔区",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "2000万人民币",
		//成立日期
		establishment: "2019-12-19",
		//经营品牌
		brand: "/",
		//主营产品
		mainProducts: "建筑材料销售，办公用品销售，日用杂品销售，五金产品销售等	",
		//企业名称
		headerTitle: "陕西中犇物资有限公司",
		moreInfoName: "陕西中犇物资有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.现款现结
		2.预付款
		3.货到付款
		4.安工程进度付款`,
		//工厂地址
		factoryAddress: "--",
		//工厂人数
		factoryHeadcount: "56",
		//产能
		capacity: "暂无信息",
		//年产值  -----> 生产基地总面积
		annualOutputValue: "15000",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "15000",
		capacity: "80万吨",

		//联系负责人
		person: "王鑫",
		//联系电话
		contactNumber: "17396600389",
		//资质证书
		// 如果没有一张证书的话 就写： qualificationList:[]
		qualificationList: [
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbzz1.jpg",
			},
		],
		//荣誉证书
		// 如果没有一个荣誉的话 就写： certificateList:[]
		certificateList: [],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工第六建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第七建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
			{
				name: "西安市政道桥建设有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb2.png",
				desc: "",
			},
			{
				name: "中铁五局",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb3.png",
				desc: "",
			},
			{
				name: "中科鸿业科技集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb4.png",
				desc: "",
			},
			{
				name: "中国建筑一局（集团）有限公司集团",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb5.png",
				desc: "",
			},
			{
				name: "陕西建工第十建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第十六建设有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第一建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第三建设集团有限公司航天分公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbhb1.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 0,
				num: 15,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 0,
				num: 9,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
	listData: {
		productList: [
			{ name: "熟石灰", img: zbcp1 },
			{ name: "生石灰", img: zbcp2 },
			{ name: "熟石灰", img: zbcp3 },
			{ name: "生石灰", img: zbcp4 },
			{ name: "电工胶布", img: zbcp5 },
			{ name: "人工草皮", img: zbcp6 },
			{ name: "铁丝", img: zbcp7 },
			{ name: "小扫把", img: zbcp8 },
			{ name: "盖土网", img: zbcp9 },
			{ name: "洗衣粉", img: zbcp10 },
			{ name: "脚手架", img: zbcp11 },
			{ name: "帆布手套", img: zbcp12 },
			{ name: "劳保鞋", img: zbcp13 },
			{ name: "水平尺", img: zbcp14 },
			{ name: "直角尺", img: zbcp15 },
			{ name: "显数卡尺", img: zbcp16 },
			{ name: "电锤", img: zbcp17 },
			{ name: "插板", img: zbcp18 },
			{ name: "剥线钳", img: zbcp19 },
			{ name: "锂电池头灯", img: zbcp20 },
			{ name: "反光马甲", img: zbcp21 },
			{ name: "安全帽", img: zbcp22 },
			{ name: "安全警戒线", img: zbcp23 },
			{ name: "记号笔", img: zbcp24 },
			{ name: "卷尺", img: zbcp25 },
		],
		navList: [
			{
				name: "石灰",
				isShow: false,
				id: 1,
				children: ["熟石灰", "生石灰", "熟石灰", "生石灰"],
			},
			{
				name: "劳保物资",
				isShow: false,
				id: 2,
				children: [
					"电工胶布",
					"人工草皮",
					"铁丝",
					"小扫把",
					"盖土网",
					"洗衣粉",
					"脚手架",
					"帆布手套",
					"劳保鞋",
					"水平尺",
					"直角尺",
					"显数卡尺",
					"电锤",
					"插板",
					"剥线钳",
					"锂电池头灯",
					"反光马甲",
					"安全帽",
					"安全警戒线",
					"记号笔",
					"卷尺",
				],
			},
		],
	},
	productDetailsData: {
		熟石灰: {
			name: "熟石灰",
			img: zbcp1,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp1,
				},
			],
			price: "--",
			detailImgs: [zbcp1],
			modelNumberText: "袋装（25kg)",
			brand: "/",
			describe: `生石灰块灰是由优质化工钙矿石（钙含量95%以上）与热卡1800的精品块煤混合烧至而成，由合格的块灰经鄂式破碎机破碎至3mm左右，粉碎成生石灰粉。生石灰和水发生化学反应生成熟石灰。建筑用灰通常都是熟石灰。                                                 熟石灰用途：将熟石灰粉和粘土混合后，称为石灰土，然后加入沙子、石屑、矿渣等，形成三种土壤。石灰和砂岩被广泛用于建筑地基和路垫。主要用于路基处理、厂房地基、停车场地基、房屋回填土等。`,
			report: [zbbg1, zbbg2, zbbg3],
		},

		生石灰: {
			name: "生石灰",
			img: zbcp2,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp2,
				},
			],
			price: "--",
			detailImgs: [zbcp2],
			modelNumberText: "块灰",
			brand: "/",
			describe: `生石灰块灰是由优质化工钙矿石（钙含量95%以上）与热卡1800的精品块煤混合烧至而成，由合格的块灰经鄂式破碎机破碎至4mm左右，粉碎成生石灰粉。生石灰和水发生化学反应生成熟石灰。建筑用灰通常都是熟石灰。                                                 熟石灰用途：将熟石灰粉和粘土混合后，称为石灰土，然后加入沙子、石屑、矿渣等，形成三种土壤。石灰和砂岩被广泛用于建筑地基和路垫。主要用于路基处理、厂房地基、停车场地基、房屋回填土等。`,
			report: [zbbg4, zbbg5, zbbg6],
		},

		熟石灰: {
			name: "熟石灰",
			img: zbcp3,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp3,
				},
			],
			price: "--",
			detailImgs: [zbcp3],
			modelNumberText: "散装",
			brand: "/",
			describe: `生石灰块灰是由优质化工钙矿石（钙含量95%以上）与热卡1800的精品块煤混合烧至而成，由合格的块灰经鄂式破碎机破碎至5mm左右，粉碎成生石灰粉。生石灰和水发生化学反应生成熟石灰。建筑用灰通常都是熟石灰。                                                 熟石灰用途：将熟石灰粉和粘土混合后，称为石灰土，然后加入沙子、石屑、矿渣等，形成三种土壤。石灰和砂岩被广泛用于建筑地基和路垫。主要用于路基处理、厂房地基、停车场地基、房屋回填土等。`,
			report: [zbbg7, zbbg8, zbbg9],
		},

		生石灰: {
			name: "生石灰",
			img: zbcp4,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp4,
				},
			],
			price: "--",
			detailImgs: [zbcp4],
			modelNumberText: "吨包",
			brand: "/",
			describe: `生石灰块灰是由优质化工钙矿石（钙含量95%以上）与热卡1800的精品块煤混合烧至而成，由合格的块灰经鄂式破碎机破碎至6mm左右，粉碎成生石灰粉。生石灰和水发生化学反应生成熟石灰。建筑用灰通常都是熟石灰。                                                 熟石灰用途：将熟石灰粉和粘土混合后，称为石灰土，然后加入沙子、石屑、矿渣等，形成三种土壤。石灰和砂岩被广泛用于建筑地基和路垫。主要用于路基处理、厂房地基、停车场地基、房屋回填土等。`,
			report: [zbbg10, zbbg11, zbbg12],
		},

		电工胶布: {
			name: "电工胶布",
			img: zbcp5,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp5,
				},
			],
			price: "--",
			detailImgs: [zbcp5],
			modelNumberText: "1cm*10m",
			brand: "/",
			describe: `电工胶布是以聚氯乙烯薄膜为基材，涂以橡胶型压敏胶制造。
			电工胶带专指电工使用的用于防止漏电，起绝缘作用的胶带。具有良好的绝缘耐压、阻燃、耐候等特性，适用于电线接驳、电气绝缘防护等特点。
			电工胶带的用途适用于各种电阻零件的绝缘。如电线接头缠绕，绝缘破损修复,变压器、马达、电容器、稳压器等各类电机、电子零件的绝缘防护。也可用于工业过程中捆绑、固定、搭接、修补、密封、保护。`,
			report: [],
		},

		人工草皮: {
			name: "人工草皮",
			img: zbcp6,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp6,
				},
			],
			price: "--",
			detailImgs: [zbcp6],
			modelNumberText: "1m*20m",
			brand: "/",
			describe: `人造草坪按生产工艺分为注塑人造草坪和编织人造草坪。注塑人造草坪采用注塑工艺，将塑料颗粒在模具中一次挤压成型，并用打弯技术将草坪弯曲，使草叶等距、等量规律排布，草叶高度完全统一。
			用途：适用于幼儿园、运动场、阳台、绿化、沙金等方面。以仿草叶状的合成纤维，植入在机织的基布，背面涂上起固定作用的涂层以作运动场上、休闲场地、高尔夫场地、庭园地坪和绿化地面上作人造草坪。
			`,
			report: [],
		},

		铁丝: {
			name: "铁丝",
			img: zbcp7,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp7,
				},
			],
			price: "--",
			detailImgs: [zbcp7],
			modelNumberText: "6#",
			brand: "/",
			describe: `铁丝是用铁拉制成的一种金属丝，铁丝按用途不同，成分也不一样，它含有的成分有：铁，钴，镍，铜，碳，锌，还有其他元素。铁丝根据粗细分成许多型号。
			用途：广泛用于工业、农业、养殖、建筑、交通运输、采矿等领域的电焊网就是用优质低碳铁丝排焊而成，然后再经过冷镀（电镀）、热镀、PVC包塑等表面钝化、塑化处理，生产出来的金属网面平整、网目均匀、焊点牢固，具有稳定、防腐、防蚀性好的特点。而不锈钢电焊网，是采用优质不锈钢丝排焊而成；如，机器防护罩、兽畜围栏、花木围栏、护窗栏、通道围栏、家禽笼及家庭办公室食品筐、纸篓及装饰用品等，更具耐酸、耐碱、焊接牢固、美观等特点。`,
			report: [],
		},

		小扫把: {
			name: "小扫把",
			img: zbcp8,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp8,
				},
			],
			price: "--",
			detailImgs: [zbcp8],
			modelNumberText: "--",
			brand: "/",
			describe: `主要原料：原材料有高梁穗、金丝草、竹梢、扫把草等。`,
			report: [],
		},

		盖土网: {
			name: "盖土网",
			img: zbcp9,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp9,
				},
			],
			price: "--",
			detailImgs: [zbcp9],
			modelNumberText: "6*20m",
			brand: "/",
			describe: `防尘网是以聚烯烃树脂为原料，并加入防老化剂和其他助剂，融化后经拉丝编制而成的轻型，高强度，耐老化的新型网状农用塑料覆盖材料。具有治理扬尘作用，遮光、降温、保湿、防暴雨、抗风及减轻虫害传播等多种功能。广泛使用于蔬菜、建筑工地防尘，防沙，花卉、果树苗、食用菌的栽培及各类养殖场的降温、保湿等。`,
			report: [],
		},

		洗衣粉: {
			name: "洗衣粉",
			img: zbcp10,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp10,
				},
			],
			price: "--",
			detailImgs: [zbcp10],
			modelNumberText: "508g/袋",
			brand: "/",
			describe: `洗衣粉是一种碱性的合成洗涤剂，是用于洗衣服的化学制剂。
			洗衣粉的主要成分是阴离子表面活性剂，烷基苯磺酸钠，少量非离子表面活性剂，再加一些助剂，磷酸盐、硅酸盐、元明粉、荧光剂、酶等，经混合、喷粉等工艺制成，现在大部分用4A氟石代替磷酸盐。洗衣粉是指粉状（粒状）的合成洗涤剂。`,
			report: [],
		},

		脚手架: {
			name: "脚手架",
			img: zbcp11,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp11,
				},
			],
			price: "--",
			detailImgs: [zbcp11],
			modelNumberText: "180*95*170cm",
			brand: "/",
			describe: `脚手架是为了保证各施工过程顺利进行而搭设的工作平台。按搭设的位置分为外脚手架、里脚手架；按材料不同可分为木脚手架、竹脚手架、钢管脚手架；按构造形式分为立杆式脚手架、桥式脚手架、门式脚手架、悬吊式脚手架、挂式脚手架、挑式脚手架、爬式脚手架。
			`,
			report: [],
		},

		帆布手套: {
			name: "帆布手套",
			img: zbcp12,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp12,
				},
			],
			price: "--",
			detailImgs: [zbcp12],
			modelNumberText: "--",
			brand: "/",
			describe: `手套按照制作方法分为缝制、针织、浸胶等。手套用各种皮革、橡胶、针织物或机织物裁剪缝制而成。针织手套用各种纺织纤维纯纺或混纺纱线，在手套机上编织，经缝制加工，如装夹里、罗口、缝指尖和指叉等，再经过拉绒或缩绒、热定形整理而成产品。针织手套的组织有平针、罗纹、集圈、纱罗等，花式有素色和色织提花等。劳动保护用手套要求比较厚实，有的经过表面涂塑处理，以提高耐磨、防滑、防水性能。装饰手套要求美观，大多经过绣花、钉珠等艺术加工。
			`,
			report: [],
		},

		劳保鞋: {
			name: "劳保鞋",
			img: zbcp13,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp13,
				},
			],
			price: "--",
			detailImgs: [zbcp13],
			modelNumberText: "39-44码",
			brand: "/",
			describe: `劳保鞋是一种对足部有安全防护作用的鞋。它的种类有很多，如保护足趾、防刺穿、绝缘、耐酸碱等。 劳保鞋的选用应根据工作环境的危害性质和危害程度进行。
			`,
			report: [],
		},

		水平尺: {
			name: "水平尺",
			img: zbcp14,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp14,
				},
			],
			price: "--",
			detailImgs: [zbcp14],
			modelNumberText: "--",
			brand: "/",
			describe: `水平尺是利用液面水平的原理，以水准泡直接显示角位移，测量被测表面相对水平位置、铅垂位置、倾斜位置偏离程度的一种计量器具。这种水平尺既能用于短距离测量，又能用于远距离的测量，也解决现有水平仪只能在开阔地测量，狭窄地方测量难的缺点，且测量精确，造价低，携带方便，经济适用。
			`,
			report: [],
		},

		直角尺: {
			name: "直角尺",
			img: zbcp15,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp15,
				},
			],
			price: "--",
			detailImgs: [zbcp15],
			modelNumberText: "--",
			brand: "/",
			describe: `直角尺，是检验和划线工作中常用的量具，简称为角尺，在有些场合还被称为靠尺。直角尺通常用钢、铸铁或花岗岩制成，按材质它可分为铸铁直角尺、镁铝直角尺和花岗石直角尺。
			用途：用于检测工件的垂直度及工件相对位置的垂直度，是一种专业量具，适用于机床、机械设备及零部件的垂直度检验，安装加工定位，划线等是机械行业中的重要测量工具。
			`,
			report: [],
		},

		显数卡尺: {
			name: "显数卡尺",
			img: zbcp16,
			modelNumber: [
				{
					title: "暂无",
					img: zbcp16,
				},
			],
			price: "--",
			detailImgs: [zbcp16],
			modelNumberText: "--",
			brand: "/",
			describe: `
			卡尺是一种量具，由主尺和游标组成，用来测量长度、内外径、深度，具有计量和检验的作用。用于长度测量工具的长度和角度的细分读数机构中。
			`,
			report: [],
		},
	},
	//联系我们
	contactListData: {
		list: [
			{
				//	姓名
				name: "赵星",
				//职位 + 负责区域  ， 跟产品对一下 要不要职位+负责区域   还是单个展示一个职位就行了
				position: "销售经理",
				//标识 1 2 34 这样给  给不同的就行
				id: "1",
				//手机号
				phoneNum: "17302925222",
				color: "#23B095 ",
				telephone: "",
				//电子邮箱
				email: "/",
			},
			{
				name: "王鑫",
				position: "销售经理",
				id: "1",
				phoneNum: "17396600389",
				color: "#23B095 ",
				telephone: "",
				email: "245964696@qq.com",
			},
			{
				name: "温闯",
				position: "销售经理",
				id: "1",
				phoneNum: "17392786682",
				color: "#23B095 ",
				telephone: "",
				email: "1075172867@qq.com",
			},
		],
	},
	//工程案例
	caseData: {
		list: [
			{
				name: "蓝田县中医医院整体搬迁建设项目", //项目名称
				id: 1, //标识 
				price: "632万元", //签约金额
				time: "2022", //签约年份
				site: "陕西省西安市蓝田县",//项目所在城市
				type: "医院", //项目分类
				unit: "陕西建工第六建设集团有限公司", //甲方单位
				//项目描述
				desc: "总建筑面积101367平方米，主要建设医疗综合楼81559平方米（其中地上建筑面积58747平方米，地下建筑面积22812平方米），康复楼8513平方米，感染性疾病门诊楼3132平方米，行政综合楼4923平方米；制剂楼2593平方米；医疗垃圾站、液氧站、污水处理站559平方米；生活垃圾站88平方米。配置电梯、扶梯、锅炉、备用发电机、变配电、医用气体等相关公用设备，配建道路、围墙、绿化、管网等室外工程。本工程概算约75892.4万元。",
				//工程图片
				imgList: [{ title: "", path: zbgc1 }],
				//现场图片 没有的话就是  proImgList:[],
				proImgList: [],
				//合同或合作证明截图
				contractList: [
					{ title: "", path: zbht1 },
				],
				//产品/服务
				product: "白灰",
			},
			{
				name: "白桦林漫步二期工程（一、二标段）施工",
				id: 2,
				price: "20万元",
				time: "2022",
				site: "陕西省西安市西咸新区",
				type: "房屋",
				unit: "陕西建工第六建设集团有限公司",
				desc: "白桦林漫步项目二期用地面积75495.62平方米，总建筑面积219255.42平方米，其中地上总建筑面积115977.21平方米，地下面积为103278.21平方米，共29栋建筑物，停车位1851个。",
				imgList: [{ title: "", path: zbgc2 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht2 },
					{ title: "", path: zbht3 },
				],
				product: "白灰",
			},
			{
				name: "西安高新区中央创新区6#能源站项目工程总承包项目",
				id: 3,
				price: "25万元",
				time: "2022",
				site: "陕西省西安市高新区",
				type: "房屋",
				unit: "陕西建工第六建设集团有限公司",
				desc: "西安高新区中央创新区 6#能源站项目工程总承包，建设内容包括新建 3 台 70MW 燃气热水锅炉房一座及配套供冷系统。",
				imgList: [{ title: "", path: zbgc3 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht4 },
				],
				product: "白灰",
			},
			{
				name: "王益区采煤沉陷区居民避险搬迁安置项目(安置区一）",
				id: 4,
				price: "15万",
				time: "2023",
				site: "陕西省铜川市王益区",
				type: "房屋",
				unit: "陕西建工第六建设集团有限公司",
				desc: "项目建设用地面积约23.23亩，新建18层住宅楼1栋、15层住宅楼1栋、12层住宅楼1栋，共314户，总建筑面积53560㎡，其中地上建筑面积39160㎡（住宅建筑面积37480㎡，配套公建建筑面积1680㎡），地下建筑面积14400㎡，配套车位392个，同时建设室外道路、管网、照明、绿化、安防、大门等配套工程。",
				imgList: [{ title: "", path: zbgc4 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht5 },
				],
				product: "白灰",
			},
			{
				name: "临潼火车站小学工程主体主体",
				id: 5,
				price: "197万",
				time: "2023",
				site: "陕西省西安市临潼区",
				type: "学校",
				unit: "陕西建工第七建设集团有限公司",
				desc: "项目位于西安市临潼区骊山街办辖区，姜寨遗址北侧;整个学校由教学楼、办公楼、体育馆及地下车库四个单体工程组成，配备有羽毛球场及体育馆等体育设施，总建筑面积11842.5㎡。其中教学楼地上五层，1-3层为普通教室，共计18间;4-5层为功能教室，共计12间;设教职工办公室及其他功能用房约30间。体育馆地上两层，一层为报告厅及配套用房，二层为室内篮球场馆。地下车库为小型车、微型车车库，采用垂直式停车，可供停车96辆。",
				imgList: [{ title: "", path: zbgc5 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht6 },
				],
				product: "白灰",
			},
			{
				name: "泾阳临空示范区滨河路EPC项目、西安国际美术博物馆一期",
				id: 6,
				price: "163万",
				time: "2022",
				site: "陕西省西安市泾阳县",
				type: "道路、房屋",
				unit: "中科鸿业科技集团有限公司",
				desc: "项目建设用地面积约23.23亩，新建18层住宅楼1栋、15层住宅楼1栋、12层住宅楼1栋，共314户，总建筑面积53560㎡，其中地上建筑面积39160㎡（住宅建筑面积37480㎡，配套公建建筑面积1680㎡），地下建筑面积14400㎡，配套车位392个，同时建设室外道路、管网、照明、绿化、安防、大门等配套工程。",
				imgList: [{ title: "", path: zbgc6 },
				          { title: "", path: zbgc7 }
			],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht7 },
				],
				product: "白灰",
			},
			{
				name: "高新纤维材料应用研发基地建设",
				id: 7,
				price: "85万",
				time: "2022",
				site: "陕西省西安市灞桥区",
				type: "厂房",
				unit: "陕西建工第十建设集团有限公司",
				desc: "高新纤维应用研发基地室外工程包含土建工程、景观工程、绿化工程、给排水工程、消防工程、电力电缆工程、弱电工程、火灾报警工程、照明工程。",
				imgList: [{ title: "", path: zbgc8 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht8 },
					{ title: "", path: zbht9 },
				],
				product: "熟石灰",
			},
			{
				name: "西安航天城水厂建设工程（二期）项目EPC工程总承包",
				id: 8,
				price: "245万",
				time: "2022",
				site: "陕西省西安市航天基地",
				type: "自来水厂",
				unit: "陕西建工第十六建设有限公司航天分公司",
				desc: "水厂建设规模35万立方米/d，其中5万立方米/d为地上水厂，30万立方米/d为地下水厂，项目总占地120亩，总建筑面积8万平方米，（其中地上计容建筑面积2.5万平方米）；配套工程包含管径d800-d1600mm、长度16km的管道及规模为5万立方米/d的提升泵站一座；",
				imgList: [{ title: "", path: zbgc9 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht10 },
				],
				product: "消石灰",
			},
			{
				name: "西安国家民用航天产业基地神舟八路（航天东路--一期南边界）市政工程",
				id: 9,
				price: "152万",
				time: "2022",
				site: "陕西省西安市航天新城",
				type: "道路工程",
				unit: "陕西建工第三建设集团有限公司航天分公司",
				desc: "本工程位于航天基地一期建设范围内，为航天基地一期建设范围内一条南北向支路，此次可行性研究报告范围为航天东路-一期南边界，道路长度2961.08m,规划红线宽度20m。包含专业道路、雨水、污水、给水、电力、照明等。",
				imgList: [{ title: "", path: zbgc10 }],
				proImgList: [],
				contractList: [
					{ title: "", path: zbht11 },
					{ title: "", path: zbht12 },
				],
				product: "熟石灰",
			},
		],
	},
	//综合评价
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			//只用管这个 法律诉讼
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				//number:就是产品提供的企业的案件数量 大于0的话  isShow:true,    等于0-> isShow:false
				isShow: false,
				number: 2,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${6}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${6}.png`,
				// title: '央视展播品牌',
				subtitle: "央视展播品牌",
				isShow: true,
			},
		],
	},
	//中标信息
	successfulBidderData: {
		//没有的话 info:[]
		info: []
			
	},
	//法律诉讼的详情
	lawData: {
		// 如果没有一条的话 info:[],
		info: [],
			
	},
	//这里是店铺详情页 顶部 公司名称下面的小标签
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},	
		],
	},
};